// extracted by mini-css-extract-plugin
module.exports = {"antiIndulgedLogin":"antiIndulgedLogin_antiIndulgedLogin_2ApEd"};